import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/outPatientTypes';

export const fetchOutPatientDetails = (payload: any): Action<any> => {
  return updateAction(actionTypes.OUTPATIENT_DETAILS, payload);
};

export const selectedFrontDeskSearch = (payload: any): Action<any> => {
  return updateAction(actionTypes.OUTPATIENT_FILTER_SEARCH, payload);
};

export const frontDeskAction = (payload: any): Action<any> => {
  return updateAction(actionTypes.FRONTDESK_ACTION, payload);
};

export const frontDeskData = (payload: any): Action<any> => {
  return updateAction(actionTypes.FRONTDESK_DATA, payload);
};
